'use client';

import { c as _c } from "react/compiler-runtime";
import type { EmblaCarouselType } from 'embla-carousel';
import { useState } from 'react';
import { PaginationDash } from '@/app/components/navigation/pagination';
import { Sliders } from '@/app/components/sliders';
import { usePaginationSlider } from '@/app/components/sliders/hooks/usePaginationSlider';
import { NewsCard } from '@/app/lcv/components/sections/news-activities/news-card';
import styles from '@/app/lcv/components/sections/news-activities/styles.module.css';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import type { LcvNewsDetail } from '@/types/tis-cms/types';
export interface NewsCarouselProps {
  data: LcvNewsDetail[];
}
export const NewsCarousel = t0 => {
  const $ = _c(14);
  const {
    data: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  const [emblaApi, setEmblaApi] = useState(null);
  const {
    currentPage,
    onPageChange,
    scrollSnaps
  } = usePaginationSlider(emblaApi);
  if (data.length === 0) {
    return null;
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      breakpoints: {
        "(min-width: 1024px)": {
          align: "start"
        }
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== data) {
    t4 = data.map(_temp);
    $[3] = data;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <Sliders onEmblaInit={setEmblaApi} loop={false} containerClassName="-ml-4 flex lg:-ml-6" hidden={false} align="center" emblaOptions={t3}>{t4}</Sliders>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== currentPage || $[8] !== onPageChange || $[9] !== scrollSnaps.length) {
    t6 = scrollSnaps.length > 1 && <PaginationDash wrapperClassName="mt-8 mb-8 flex justify-center md:mt-6 md:mb-0 xl:mt-10" theme="dark" totalPages={scrollSnaps.length} currentPage={currentPage} onPageChange={onPageChange} />;
    $[7] = currentPage;
    $[8] = onPageChange;
    $[9] = scrollSnaps.length;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(news, index) {
  return <div key={news.documentId ?? `${news.url}-${index}`} className={cn("pl-4 lg:pl-6", "max-w-98 flex-none basis-125 lg:max-w-125", styles.carouselCard)} {...createDataAttributes({
    test: `item-${index}`
  })}><NewsCard news={news} index={index} /></div>;
}